import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { getDeletedBets } from "@tvg/sh-lib-my-bets/redux/selectors";
import queryHelper from "../graphql/behgOptions.graph";
import { GET_GROUP_WAGERS_MY_BETS } from "../graphql/queries/GroupWagers";
import { GroupWagersQueryProps, WagerHistoryData } from "../types";

const useGetGroupWagers = ({
  accountNumber,
  behgClient,
  selectedSettledTab,
  selectedTab,
  hasPagination,
  wagersPerPage
}: GroupWagersQueryProps) => {
  const deletedBets: string[] = useSelector(getDeletedBets);

  const {
    data,
    loading: isLoadingBehg,
    subscribeToMore
  } = useQuery<WagerHistoryData>(
    GET_GROUP_WAGERS_MY_BETS,
    queryHelper.apolloOptions({
      accountNumber,
      behgClient,
      selectedSettledTab,
      selectedTab,
      hasPagination,
      wagersPerPage
    })
  );

  return {
    queryBets: queryHelper.getActiveBetsInfo(
      data,
      selectedSettledTab,
      selectedTab,
      deletedBets
    ),
    hasBehgData: !!data,
    isLoadingBehg,
    subscribeToMore
  };
};

export default useGetGroupWagers;
